import liveidImg from '../../../../assets/sentryone/liveid.png';
import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

import pdf from '../../../../assets/pdf/LiveID-Pro.pdf';

export const LiveIDUseCases = (props) => {

  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);

  return (
    <div id='about'>
      <div className='container'>
        <div className='row'>
          <div className='col-xs-12 col-md-6' data-aos='fade-up'>
            <div className='about-text'>
              <h2>What is LiveID Pro?</h2>
              <p>LiveID Pro is a centralized biometric attendance platform engineered for structured, multi-location workforce environments. Designed for high-accountability projects and regulated deployments, the system enables secure fingerprint-based attendance capture integrated with a unified web management console. It delivers accuracy, operational transparency, and audit-ready compliance — eliminating manual errors and proxy attendance risks.</p>

              <h3>Features of LiveID Pro</h3>
              <div className='list-style'>
                <div className='col-lg-6 col-sm-6 col-xs-12'>
                  <ul>
                    <li>Biometric Fingerprint</li>
                    <li>Centralized Web Console</li>
                    <li>Multi-Location Support</li>
                  </ul>
                </div>
                <div className='col-lg-6 col-sm-6 col-xs-12'>
                  <ul>
                    <li>HRMS & Payroll Integration</li>
                    <li>Role-Based Access Control</li>
                    <li>Audit-Ready Compliance</li>
                  </ul>
                </div>
              </div>

              <div style={{ marginTop: 150 }}>
                <a
                  href={pdf}
                   download="LiveID-Pro.pdf"
                  className='btn btn-custom btn-lg'
                  data-aos='fade-up'
                >
                  <i className='fa fa-download' style={{ marginRight: 8 }} />
                  Download Brochure
                </a>
              </div>

            </div>
          </div>
          <div className='col-xs-12 col-md-6'>
            {' '}
            <img style={{ height: 600 }} data-aos='fade-up' src={liveidImg} className='img-responsive' alt='' />{' '}
          </div>
        </div>
      </div>
    </div>
  );
};